module.exports = __webpack_public_path__ + "static/media/Cartaz_Cipa_Copams_Juntos_contra_o_assedio.ec5df577.jpg";